import {
    request2
} from './request.js'

//获取列表
let getList = function (obj, index, size) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/Pagination',
        method: 'get',
        params: {
            name: obj.name,
            openCourseTitle: obj.openCourseTitle,
            headTeacherName: obj.headTeacherName,
            gradeCategoryId: obj.gradeCategoryId,
            YearId: obj.YearId,
            pageIndex: index,
            pageSize: size
        }
    })
}
let GetGradeNoPageDtos = function (obj) {
    let length1 = obj.GradeIds?.length || 0
    let GradeId = ''
    for (let i = 0; i < length1; i++) {
        if (i == length1 - 1) {
            GradeId += `gradeIds=${obj.GradeIds[i]}`
        } else {
            GradeId += `gradeIds=${obj.GradeIds[i]}&`
        }
    }

    return request2({
        url: `/api2/TZsbAdminTeachApi/Grade/GetGradeNoPageDtos?${GradeId}`,
        method: 'get',
        params: {
            GradeName: obj.GradeName,
            HeadTeacherId: obj.HeadTeacherId,
            PageSize:200
        }
    })
}

// 授课老师
let acquireTeacher = function (data) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/AdminTeacher/AcquireTeacher',
        method: 'post',
        data: {
            keyWord: data.keyword,
            ids: data.ids,
            pageSize: data.pageSize
        }
    })
}

//获取详情
let getInfo = function (id) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}

let addGrade = function (obj) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/Create',
        method: 'post',
        data: {
            liveRoomId:obj.liveRoomId,
            name: obj.name,
            yearId: obj.yearId || 0,
            openCourseId: obj.openCourseId,
            openCourseTitle: obj.openCourseTitle,
            gradeCategoryId: obj.gradeCategoryId,
            limitNumber: obj.limitNumber,
            headTeacherId: obj.headTeacherId,
            headTeacherName: obj.headTeacherName,
            gradeTeachers: obj.gradeTeachers,
            isOpenWork:obj.isOpenWork,
            isWorkHide:obj.isWorkHide,
        }
    })
}

let editGrade = function (obj) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/Modify',
        method: 'post',
        data: {
            liveRoomId:obj.liveRoomId,
            id: obj.id,
            name: obj.name,
            yearId: obj.yearId || 0,
            openCourseId: obj.openCourseId,
            openCourseTitle: obj.openCourseTitle,
            gradeCategoryId: obj.gradeCategoryId,
            limitNumber: obj.limitNumber,
            headTeacherId: obj.headTeacherId,
            headTeacherName: obj.headTeacherName,
            gradeTeachers: obj.gradeTeachers,
            isOpenWork:obj.isOpenWork,
            isWorkHide:obj.isWorkHide,
        }
    })
}

let deleteGrade = function (ids) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/Delete',
        method: 'post',
        data: {
            "gradeIds": ids
        }
    })
}

//获取指定范围
let getSpecifiedRangeGradeList = function (ids, keyWord, pageSize) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/GetSpecifiedRangeGradeList',
        method: 'post',
        data: {
            keywords: keyWord, //搜索关键字
            gradeIds: ids, //指定iD集合
            pageSize: pageSize //返回数目
        }
    })
}

//获取班级分类分页列表
let getClassCategoryList = function (keywords, index, size) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/Pagination',
        method: 'get',
        params: {
            name: keywords,
            pageIndex: index,
            pageSize: size
        }
    })
}

let getListInfo = function () {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/List',
        method: 'get',
    })
}

//获取单个类详情
let getClassCategoryInfo = function (id) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}

let addCategory = function (obj) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/Create',
        method: 'post',
        data: {
            name: obj.name,
            description: obj.description
        }
    })
}

let editCategory = function (obj) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/Modify',
        method: 'post',
        data: {
            id: obj.id,
            name: obj.name,
            description: obj.description
        }
    })
}

let deleteCategory = function (ids) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/GradeCategory/Delete',
        method: 'post',
        data: {
            "gradeCategoryIds": ids
        }
    })
}
//获取班级下的学员列表
let GetSpecifiedRangeListTwo = function (obj) {
    return request2({
        url: '/api2/TZsbAdminTeachApi/Grade/GetSpecifiedRangeListTwo',
        method: 'get',
        params: {
            StudentName: obj.StudentName,
            GradeId: obj.GradeId,
            PageSize: obj.PageSize,
            ProductId:obj.ProductId || null,
            MainProductId: obj.MainProductId || null,
            BusinessId: obj.BusinessId || null
        }
    })
}
// 批量开启作业助手
export function UpdateIsOpenWork(isOpenWork,data) {
    return request2({
      url: '/api2/TZsbAdminTeachApi/Grade/UpdateIsOpenWork',
      method: 'post',
      params: {
        IsOpenWork: isOpenWork,
      },
      data:data
    })
  }
  // 批量开启作业隐藏
export function UpdateIsWorkHide(isWorkHide,data) {
    return request2({
      url: '/api2/TZsbAdminTeachApi/Grade/UpdateIsWorkHide',
      method: 'post',
      params: {
        IsWorkHide: isWorkHide,
      },
      data:data
    })
  }
    // 批量将已分班数据--设为失效状态
export function DeleteGradeMember(data) {
    return request2({
      url: '/api2/TZsbAdminTeachApi/GradeMemberDistribution/DeleteGradeMember',
      method: 'post',
      data:data
    })
  }

export {
    getList,
    getInfo,
    addGrade,
    acquireTeacher,
    editGrade,
    deleteGrade,
    getSpecifiedRangeGradeList,
    getClassCategoryList,
    getListInfo,
    getClassCategoryInfo,
    addCategory,
    editCategory,
    deleteCategory,
    GetGradeNoPageDtos,
    GetSpecifiedRangeListTwo
}